import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/switching/value/standard-16-poe.png";
import type { Product } from "../../types";
import { switchingValue } from "../product-list-groups/switchingValue";
import {
  downlinkSpeed,
  etherlighting,
  mounting,
  outdoorReady,
  poeAvailability,
  poeOutput,
  portCount,
  powerMethod,
  proAvSupport,
  switchTechnology,
  uplinkSpeed,
} from "../properties";

export const standard16PoE: Product = {
  id: "standard16PoE",
  productTitle: "Standard 16 PoE",
  description: "standard16poe.description",
  techspecsPath: [SiteId.TechSpecs, "/unifi/switching/usw-16-poe"],
  storePathParts: { productSlug: "usw-16-poe", category: "switching-standard" },
  sku: "USW-16-POE",
  image: { src: image, width: 200, height: 140 },
  productListGroup: switchingValue,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '442 x 200 x 44 mm\n(17.4 x 7.9 x 1.7")',
      },
    },
    {
      propertyId: switchTechnology.id,
      value: {
        type: "translation",
        value: "commons.switchingTechnology.layer2",
      },
    },
    {
      propertyId: portCount.id,
      value: { type: "string", value: "16" },
    },
    {
      propertyId: downlinkSpeed.id,
      value: { type: "string", value: "1 Gbps" },
    },
    {
      propertyId: uplinkSpeed.id,
      value: { type: "string", value: "1 Gbps" },
    },
    {
      propertyId: poeOutput.id,
      value: {
        type: "translation",
        value: "commons.poeOutput.upToPoe+",
      },
    },
    {
      propertyId: poeAvailability.id,
      value: { type: "string", value: "42 W" },
    },
    {
      propertyId: etherlighting.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: proAvSupport.id,
      value: { type: "boolean", value: false },
    },

    {
      propertyId: "generalRedundancy",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: powerMethod.id,
      value: {
        type: "translation",
        value: "commons.powerMethod.acPower",
      },
    },
    {
      propertyId: mounting.id,
      value: {
        type: "translation",
        value: "commons.mounting.rack",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "boolean", value: false },
    },
  ],
};
